const tc = {
  header: {
    home: "餐飲",
    about: "關於我們",
    love: "婚宴及推廣",
    link: "投資者關係",
    contact: "聯繫我們",
    hover: {
      home: "主頁",
      coffee: "猫屎咖啡",
      restaurant: "餐飲服務",
      about: "關於我們",
      investor: "投資者關係",
      contact: "聯繫我們",
      join: "加入我們"
    }
  },
  footer: {
    title1: "免責聲明",
    title2: "使用條款",
    title3: "隱私政策及聲明",
    company: "猫屎咖啡控股有限公司"
  },
  home: {
    map_title: "關於利寶閣",
    map_content: "利寶閣經營中式餐飲服務，業務遍佈香港及內地。憑藉對粵菜的熱誠及食客為先的理念，集團以旗艦品牌「利寶閣」於中港兩地開設酒家",
    find_title: "發現 我們的故事",
    find_content: "利寶閣是一家餐飲企業，提供粵菜佳肴﹑中式筵席及餐飲服務。",
    find_btn: "聯繫我們",
    company_title: "餐飲品牌",
    company_more: "點擊此處，了解更多詳情"
  },
  about: {
    title: "關於我們",
    title1: "粵菜翹楚",
    content1: "「利寶閣」是香港知名的餐飲品牌之一，以傳統粵菜聞名。集團第一家酒樓於 1998 年在香港銅鑼灣隆重開業，多年來憑著對粵菜的熱誠及卓越的經營，集團的業務版圖已延伸至中國內地，成為一間營運模式多元化及規模龐大的香港上市餐飲企業。",
    title2: "推陳出新 奮勇開創新篇章",
    content2: "集團呈獻的正宗粵菜經過精烹細琢，結合上乘的食材及精湛的廚藝，廣受食客推崇。長久以來，集團在菜式上致力推陳出新，細膩演繹粵菜經典的同時，為食物注入各種創新元素，在滿足食客味蕾的同時，亦為食客帶來具新鮮感的餐飲體驗。集團推出的創新陳皮烤鴨及栩栩如生的造型點心已成為品牌的標誌菜式，也是食客到訪利寶閣必嘗的美食。深耕香港市場多年後，「利寶閣」品牌聲譽滿載；2013 年集團正式進軍內地市場，在深圳福田開設集團內地的首家酒樓。憑著力臻完善的經營態度，加上優質的食品，利寶閣品牌在內地深受食客歡迎；短短幾年間，集團已在深圳開設三間分店，其食物品質大受好評。 2016 年，集團於香港聯交所創業板上市；2018 年，集團轉至主板上市，充分反映資本市場對集團的認同。",
    title3: "與時俱進 積極開拓新零售模式",
    content3: "作為一間與時俱進的企業，利寶閣為廣大消費者帶來全新的消費模式，抓緊互聯網餐飲帶來的蓬勃機遇。 2019 年集團與阿里巴巴集團旗下的電商品牌盒馬鮮生建立戰略合作關係；背靠盒馬的強大網絡以實體店 + 網上訂購平台的新零售模式，提供餐飲外賣及送餐市場。根據協議，利寶閣於盒馬鮮生內開設店中店，銷售現場烹制的港式燒味餐膳食品，以及提供湯水、點心、甜品及節日食品等具特色的菜式，務求令客人安坐家中，就可品嘗到新鮮佳肴。",
    content4: "2020 年，集團在中國的業務更上一層樓。集團成功收購國內燒臘行業領軍者之一的上海新玖記 70% 股份，以配合集團以輕資產的商業模式開拓中國「新零售」輕膳送餐市場的布局。上海新玖記有豐富的新零售經驗，其烤鴨食品揚名中外。",
    content5: "默默耕耘廿多年，集團已由一家傳統酒樓發展成為一間多元餐飲服務的領先企業，業務涵蓋中式筵席、O2O 輕膳送餐服務等；業務版圖覆蓋香港、深圳及上海等市場。 「利寶閣」品牌不僅僅承傳粵菜的經典，也展演出一份創新求變、追求卓越的企業家精神。",
    history: {
      title: "發展歷程"
    },
  },
  wedding: {
    title: "婚宴場地",
    new_title: "最新推廣及活動"
  },
  disclaimer: {
    title: "免責聲明",
    t: "本網站所載資料只供參考，如有更改，恕不另行通知。本公司並不保証該等資料之准確性及完整性。對於使用或依賴本網站資料，或因經本網站連結所取得之其他互聯網資料，所引致的任何損失，本公司概不負責。\n" +
      "‍\n" +
      "互聯網使用者可自行複製、發佈或傳遞有關資料作個人使用，唯不能作任何商業用途；使用時必須完整複製，並須標明資料來源。本公司不會就資料之使用負上任何責任。"
  },
  use: {
    title: "使用條款",
    t: "歡迎瀏覽貓屎咖啡控股有限公司(下稱「貓屎咖啡」或「我們」或「我們的」)的網站。凡於使用條款及細則內提述「閣下」及「閣下的」包括進入本網站的任何人士。\n" +
      "‍\n" +
      "在使用本網站及其內容(下稱「本網站」)前，請仔細閱讀以下有關使用本網站的條款及細則(下稱「使用條款」)。鑒於閣下使用本網站時，即表明閣下同意使用條款。我們有權於任何時間修訂或更改使用條款。任何修訂或更改將於本網站上發布。若閣下繼續使用本網站，即表明接受該等修訂或更改之約束。\n" +
      "‍\n" +
      "閣下同意不會(a)干擾或試圖干擾我們的軟件之正常運作或任何透過本網站而傳送的任何服務；(b)在未經授權情況下，進入或試圖進入我們的電腦系統或其他使用者的電腦系統；(c)收集或試圖收集其他使用者的資料；或(d)作出任何導致或可能導致我們提供予使用者之服務受到中斷或質量降低的行為或本網站被改變或塗污的行為。\n" +
      "‍\n" +
      "1. 擁有權\n" +
      "1.1 關於本網站及其設計之所有知識產權及商譽是屬於我們或第三者或由我們或第三者已合法地獲取特許/牌照用於本網站。閣下不得復製、復印、修改、更改、變更、修訂、傳送、載錄、散布、分發、宣報、刊載或顯示本網站或儲存於檢索系統或使用本網站製作任何衍生作品或銷售本網站提供之產品或服務或侵犯我們或第三者的知識產權，惟閣下可將本網站任何部份下載一份至任何一部電腦作閣下之私人及非商業性用途，但閣下必須將所有版權及其他所有權聲明完整地保留。使用條款在任何情況下，不會被詮釋為向閣下授予任何屬於我們或第三者之知識產權或商譽的權利、所有權或權益。我們或第三者特此保留一切適用法律之權利。\n" +
      "‍\n" +
      "1.2 閣下同意在未得我們事先書面同意之前，不可將本網站顯示在框格(frame)或與本網站連結(link)或將閣下與本網站相聯。\n" +
      "‍\n" +
      "2. 內容\n" +
      "貓屎咖啡經已作出一切合理安排以確保本網站所提供之資訊及資料均為正確及最新的。但是，我們否認所有明示或隱含的保證，並不會就該等資訊及資料之準確性、適時性、充足性、可靠性或完整性作出任何表述。\n" +
      "‍\n" +
      "3. 本網站之使用\n" +
      "3.1 閣下不得濫用本網站，藉本網站引進病毒、蠕蟲病毒(worms)、邏輯炸彈病毒、惡意的或技術上有害的或含有污染或破壞元素的其他材料。閣下在未經許可情況下，不得存取或試圖存取本網站、儲存本網站之伺服器或電腦、或與本網站相連之任何伺服器、電腦或資料庫。\n" +
      "‍\n" +
      "3.2 閣下不得利用本網站傳送虛假、非法、騷擾性、誹謗性、辱罵性、憎恨性、歧視的、威嚇的、有害的、粗俗的、猥褻的、煽動性或其他引起反對或冒犯性之任何種類或性質的材料。\n" +
      "‍\n" +
      "3.3 閣下同意只可使用本網站作非商業性、個人及合法之用途。\n" +
      "‍\n" +
      "3.4 因閣下使用本網站而導致任何病毒、蠕蟲病毒(worms)、邏輯炸彈病毒、含有污染或破壞元素的材料或其他惡意或技術上有害的材料有可能影響閣下的設備、資料庫或其他材料所產生的任何損失或損害，我們概不負責。\n" +
      "‍\n" +
      "3.5 我們保留權利可在不作通知的情況下，於任何時間終止閣下進入本網站或拒絕讓閣下使用本網站或其服務。\n" +
      "‍\n" +
      "4. 個人資料收集聲明\n" +
      "當閣下使用本網站，閣下可能向我們提供你的個人資料。閣下同意所提供的該等個人資料乃屬自願性質。我們有權因應收集目的及適用法律繼續保留該等個人資料。我們會根據我們的私隱政策使用閣下的個人資料，閣下亦同意接受我們的私隱政策，有關政策可從私隱政策連結參閱。閣下確認閣下所提供的資料是屬實、正確、有效和完整的。\n" +
      "‍\n" +
      "5. 保證及法律責任\n" +
      "5.1 閣下同意是在風險自負之情況下使用本網站。就使用本網站、依靠本網站提供有關貓屎咖啡、我們之相關聯公司、附屬公司、母公司、聯繫公司、供應商及/或業務夥伴之任何資訊或資料、本網站遺漏任何有關貓屎咖啡、我們之相關聯公司、附屬公司、母公司、聯繫公司、供應商及/或業務夥伴之資訊或資料、任何上載至本網站的材料或與本網站之連結，我們概不負責。\n" +
      "‍\n" +
      "5.2 我們沒有代表任何第三者之授權。閣下同意我們不會就閣下與第三者之任何索償、糾紛、償付或合約承擔任何責任。\n" +
      "‍\n" +
      "5.3 本網站之資料是按\"現狀\"提供的，當中並沒有包含任何明確或隱含保證。我們可在不作事先通知的情況下，於任何時間對其作出更改。\n" +
      "‍\n" +
      "5.4 我們不就下述情形作出任何明示或隱含的聲明或保證:\n" +
      "(a)本網站可於任何時間在持續及不被中斷之基礎上可供存取或本網站之運作、品質及供存取性能；\n" +
      "(b)本網站或任何透過本網站取得的材料是沒有病毒、蠕蟲病毒(worms)、邏輯炸彈病毒、惡意或技術上有害的材料或含有污染或破壞元素的材料包括但不限於該等病毒或其他程式會令閣下之資料或財產受損；\n" +
      "(c)使用本網站將取得任何特定結果；及\n" +
      "(d)糾正本網站的任何不足之處。\n" +
      "‍\n" +
      "5.5 若閣下因使用本網站而須更換任何設備或軟件或資料庫受損，我們概不負責。\n" +
      "‍\n" +
      "5.6 因使用或不能使用本網站或使用或依靠本網站之任何資訊而導致的任何損失(不論直接、間接、特殊或必然的)、損害或傷害(不論是否合約、侵權(包括疏忽)、違反法定責任或其他行為)，即使是可預見的，閣下同意豁免我們的法律責任或將其減至法律範圍內最低。為免生疑，使用條款並不免除或局限我們因我們、我們的僱員或代理人之疏忽或欺詐或失實陳述所引致死亡或人身傷害的責任。\n" +
      "‍\n" +
      "5.7 於互聯網上傳遞之訊息並不保證絕對安全；同時，閣下因透過互聯網向貓屎咖啡、我們之相關聯公司、附屬公司、母公司、聯繫公司、供應商及/或業務夥伴傳送訊息或要求貓屎咖啡、我們之相關聯公司、附屬公司、母公司、聯繫公司、供應商及/或業務夥伴透過互聯網向閣下發出之訊息如有任何延誤、損失、誤傳、變更或損毁，我們對此而引致之損失或損害，概不負責。\n" +
      "‍\n" +
      "6. 彌償\n" +
      "因閣下違反使用條款、或不遵守使用條款或透過本網站而取得的任何材料所引致的任何責任，閣下同意完全彌償我們、我們之附屬公司、母公司、僱員及代理人因此所引致的全部申索、損失、損害、費用及支出(包括法律費用)，並就任何申索、損失、損害、費用及支出(包括法律費用)為我們、我們之附屬公司、母公司、僱員及代理人進行抗辯。\n" +
      "‍\n" +
      "7. 可分割性\n" +
      "使用條款的任何條文在某司法管轄區的法律若屬不合法、無效或無法執行，將不影響該有關條文在其他司法管轄區的合法性、有效性及可執行性，同時，也不會影響其他條文的合法性、有效性及可執行性。\n" +
      "‍\n" +
      "8. 一般事項\n" +
      "8.1 本使用條款的中英文本如有任何矛盾或不一致，應以中文本為準，英文僅供參考。\n" +
      "‍\n" +
      "8.2 本使用條款根據香港特別行政區(\"香港\")法律詮釋，並受香港法律管轄。就使用條款或閣下使用本網站所引致的任何糾紛，閣下同意香港法庭享有專有司法管轄權。\n" +
      "‍\n" +
      "9. 雜項\n" +
      "任何違反事項之寬免並不構成對其他違反事項之寬免。使用條款內之標題僅為方便參考而設，不影響使用條款的詮釋。"
  },
  desc: {
    title: "私隱政策及聲明",
    t: "本聲明旨在說明貓屎咖啡控股有限公司(「貓屎咖啡」或下稱「我們」或「我們的」)透過位於http://kafelaku.com的網頁(下稱「本網站」)就有關收集閣下的個人資料(下稱「資料」)及其使用的處理方法。凡於本聲明內「閣下」或「閣下的」包括進入本網站及提交資料的任何人士。\n" +
      "‍\n" +
      "請仔細閱讀本聲明。鑒於閣下使用本網站或向我們遞交閣下的資料，即表明閣下同意接受本聲明。我們有權於任何時間修訂或更改本聲明。任何修訂或更改將於本網站上發布。在本聲明修訂或更改後，若閣下繼續使用本網站，即表明接受該等修訂或更改之約束。無論如何，若有任何修訂或更改關於我們如何收集及使用閣下的資料，我們會在作出該修訂或更改前向閣下取得同意。\n" +
      "‍\n" +
      "1. 個人資料(私隱)條例\n" +
      "就閣下的資料之收集、運用、貯存、保留、披露、轉移、提供、供存取、保護及存取，我們遵守個人資料(私隱)條例(香港特別行政區法例第486章)所述的規定。\n" +
      "‍\n" +
      "2. 收集資料及資訊\n" +
      "2.1 當閣下使用本網站，我們可能向閣下收集資料，包括但不限於閣下的姓名、地址、聯絡資料(包括電話、流動電話及傳真號碼)、信用咭資料(若閣下訂購我們的產品或服務)、電郵地址、網際網路通訊協議(IP)地址、操作系統的類型、瀏覽器類別、域名、登入時間及與閣下要求獲取資料或服務有關的其他人士的其他資料，並會作下列用途:\n" +
      "(a) 就招聘、產品及服務提供及/或顧客服務之用途作身份核實及紀錄；\n" +
      "(b) 以達成閣下對我們的產品或服務訂購要求，並處理訂單、付款及任何帳項償付；\n" +
      "(c) 於我們的內部數據庫保存通訊聯絡資料；\n" +
      "(d) 匯制本網站使用量的統計；\n" +
      "(e) 回應及處理閣下的任何查詢或執行閣下的要求；\n" +
      "(f) 對我們的產品及服務作出評估及提升；及\n" +
      "(g) 進行與我們客戶、產品、服務、活動、推廣或項目有關的調查。\n" +
      "‍\n" +
      "2.2 閣下確認並同意閣下提供的資料屬自願性質。\n" +
      "‍\n" +
      "2.3 閣下可以發送電郵至enquiry@kafelaku.com，隨時更改閣下就收取我們的資訊及資料所作的選擇或閣下的資料。\n" +
      "‍\n" +
      "3. 使用資料作直接促銷\n" +
      "3.1 我們亦會使用閣下的資料向閣下發送直接促銷訊息，例如當中包含關於食品、飲料、餐飲產品及服務的消息、報價和推廣之郵件、電子郵件、電話或短信。\n" +
      "‍\n" +
      "3.2 我們不會在未得閣下之書面同意前向任何第三方提供閣下的資料作直接促銷用途。\n" +
      "‍\n" +
      "3.3 如閣下不欲收取任何直接促銷訊息，請隨時將你的要求連同你的姓名發送電郵至enquiry@kafelaku.com。\n" +
      "‍\n" +
      "4. 保安\n" +
      "我們會使用適當的安全技術及程序以保護閣下的資料，避免在未經授權情況下被存取、使用或披露。惟鑑於互聯網之性質及技術，其他人仍有可能截取閣下發送至或傳經本網站的資訊。我們不保證本網站不受黑客入侵或攻擊。\n" +
      "‍\n" +
      "5. 披露、保留及貯存資料\n" +
      "5.1 閣下確認、同意並授權我們把資料保留及貯存在我們的一個或多個在香港境內或外的數據庫內。\n" +
      "‍\n" +
      "5.2 除非閣下事先同意或法律允許，我們不會向任何第三方轉移、披露、提供或供存取閣下的資料，惟下文所述情況除外：\n" +
      "(a)我們之附屬公司為專業機構膳食有限公司；\n" +
      "(b)我們的僱員；\n" +
      "(c)信貸公司以進行付款交易；\n" +
      "(d)按適用法律、法庭命令、行政政策或規例、指引、指令或於香港或香港以外的任何監管、政府、稅務、執法或其他機構，或自律規管團體或業界團體所頒布或發布的命令，或與法律程序有關，或為在香港確立、行使或抗辯的法律權利，要求我們必須向其披露之任何人士或機構；\n" +
      "(e)就我們的業務、合併、收購或轉讓而作出盡職審查為目的，而須予以披露之任何人士、機構或個體；\n" +
      "(f)因危及生命或緊急情況下並有助於識別個人為由，我們須向有關人士、機構、個體或機關作出披露。\n" +
      "閣下確認、同意並授權我們在執行，實施或遵守我們之使用條款及細則的任何條款或本聲明的情況下轉移、披露、提供或供存取閣下的資料。\n" +
      "‍\n" +
      "6. 查閱及更正資料\n" +
      "閣下有權查閱我們是否持有有關你的資料並存取任何該等資料，如有需要，閣下亦有權要求更正或更新該等資料。倘若閣下希望存取、更正或更新閣下的資料，請發送電郵至enquiry@kafelaku.com。在符合《個人資料(私隱)條例》之下我們會致力於40天內對閣下的要求作出回應。\n" +
      "‍\n" +
      "7. 曲奇檔案(Cookies)\n" +
      "我們可能在本網站上使用曲奇檔案。曲奇檔案是由網站自動儲存於個人電腦網絡瀏覽器的小量資料，這些資料可以由該網站檢索。曲奇檔案所收集的信息是匿名的聚集研究數據，並沒有包含名稱或地址信息或使任何人可以通過電話，電子郵件或任何其他方式與閣下聯繫之任何信息。大多數瀏覽器最初設定都接受曲奇檔案。倘若閣下希望停止曲奇檔案的運作，閣下可以更改閣下的瀏覽器設定。無論如何，由於本網站的某些功能需要曲奇檔案方能運作，例如：在過程中保持連續性，如果它們被停止，這些功能可能無法正常運作，這樣或會使我們的部份網頁不能正確或完全不能顯示。\n" +
      "‍\n" +
      "8. 未成年人士\n" +
      "我們沒有責任查證閣下的年齡，並假定閣下已年滿十八歲或以上。若閣下年齡未滿十八歲，或無能力締結合約，在未得到你的父母/監護人事前同意情況下，閣下不應在本網站提供任何閣下的資料。我們建議兒童/未成年人士須在父母/監護人監督下上網。\n" +
      "‍\n" +
      "9. 一般事項\n" +
      "本聲明的中英文本如有任何矛盾或不一致，應以中文本為準，英文僅供參考。\n" +
      "‍\n" +
      "10. 其他問題\n" +
      "倘若閣下有任何與本聲明有關的查詢，請發送電郵至enquiry@kafelaku.com。"
  }
};
export default tc;



// WEBPACK FOOTER //
// ./src/i18n/locale/tc.js